import { gql } from "@apollo/client"

export const GET_ADDRESS_VALIDATION_RULES = gql`
  query checkAddressValidation($countryCode: CountryCode!) {
    addressValidationRules(countryCode: $countryCode) {
      countryName
      allowedFields
      addressFormat
      addressLatinFormat
      requiredFields
      countryAreaChoices {
        raw
        verbose
      }
      countryAreaType
    }
  }
`
